import React from 'react';
import { PlanningState } from '../model/Planning';
import { Image } from './Image';

export interface SlotProps {
  date: Date;
  userName: string;
  userId: number;
  isClient: boolean;
  state: PlanningState;
  address: string;
}

export const PlanningSlotViewer: React.FC<SlotProps> = (props) => {
  return (
    <article className="slot-card">
      <Image id={props.userId} isClient={!props.isClient} compact={true} />
      <div>
        <div><b>{props.isClient ? 'Coach:' : 'Client:'}</b> {props.userName}</div>
        <div><b>Date:</b> {new Date(props.date).toLocaleDateString()} {new Date(props.date).toLocaleTimeString()}</div>
        <div><b>Lieu:</b> {props.address}</div>
        <div><b>Etat:</b> {PlanningState[props.state].toString()}</div>
      </div>
    </article>
  );
};
